var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-textarea',{attrs:{"no-resize":"","outlined":"","value":_vm.value,"label":_vm.label,"color":_vm.color,"rules":_vm.rules},on:{"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }